import { isSSR } from '@helpers/ssr';
import React from 'react';
import { BrowserRouter as Router, StaticRouter } from 'react-router-dom';

export function withRouter<T>(WrappedComponent: React.ComponentType<T>): typeof ComponentWithRouter {
  const displayName = WrappedComponent.displayName || WrappedComponent.name || 'Component';

  const ComponentWithRouter: React.FC<T> = (props) => {
    if (isSSR) {
      return (
        <StaticRouter>
          <WrappedComponent {...props} />
        </StaticRouter>
      );
    }

    return (
      <Router>
        <WrappedComponent {...props} />
      </Router>
    );
  };

  ComponentWithRouter.displayName = `withRouter(${displayName})`;

  return ComponentWithRouter;
}
